import { render, staticRenderFns } from "./TransWorkorder.vue?vue&type=template&id=66ca48c4&scoped=true"
import script from "./TransWorkorder.vue?vue&type=script&lang=js"
export * from "./TransWorkorder.vue?vue&type=script&lang=js"
import style0 from "./TransWorkorder.vue?vue&type=style&index=0&id=66ca48c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ca48c4",
  null
  
)

export default component.exports